import { render, staticRenderFns } from "./WizardError.vue?vue&type=template&id=2dea5eb5&"
import script from "./WizardError.vue?vue&type=script&lang=js&"
export * from "./WizardError.vue?vue&type=script&lang=js&"
import style0 from "./WizardError.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports